export default {
      id: "projects-in-progress-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#projects-in-progress-usage",
      toString: function () {
        return this.url;
      }
    }